/**
 * MembershipBenefitsList Component
 * 
 * Reusable component for displaying membership tier benefits.
 * Used in tier cards, upgrade dialogs, and success screens.
 */

import { useTranslation } from 'react-i18next'
import { Check } from 'lucide-react'
import type { MembershipTierConfig } from '../../types'

interface MembershipBenefitsListProps {
  tier: MembershipTierConfig
  variant?: 'default' | 'compact'
  showIcons?: boolean
}

export function MembershipBenefitsList({
  tier,
  variant = 'default',
  showIcons = true
}: MembershipBenefitsListProps) {
  const { t } = useTranslation()

  const iconClass = 'h-4 w-4 mt-0.5 flex-shrink-0 text-green-500'
  const spacingClass = variant === 'compact' ? 'space-y-1.5' : 'space-y-2'

  return (
    <ul className={spacingClass}>
      <li className="flex items-start gap-2 text-sm">
        {showIcons && <Check className={iconClass} />}
        <span>
          {tier.free_downloads_per_month} {t('membership.freeTakesPerMonth', 'free takes/month')}
        </span>
      </li>
      {tier.translation_discount_percent > 0 && (
        <li className="flex items-start gap-2 text-sm">
          {showIcons && <Check className={iconClass} />}
          <span>
            {tier.translation_discount_percent}% {t('membership.discountOnTranslations', 'discount on translations')}
          </span>
        </li>
      )}
    </ul>
  )
}

